/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SortDirection, SortSelector, Option } from "~/components";
import { SELECT_OPTIONS } from "../constants";
import { SortByOrder, SortByValue } from "../types";

type Props = {
  sortField: string;
  sortDirection: SortByOrder;
  onSortSelect: (value: SortByValue) => void;
  onSortOrderChange: (value: SortDirection) => void;
  options?: Option[];
};

export function SettingsSort({
  sortField,
  sortDirection,
  onSortSelect,
  onSortOrderChange,
  options = SELECT_OPTIONS,
}: Props) {
  return (
    <SortSelector
      options={options}
      value={sortField}
      direction={
        sortDirection === SortByOrder.Ascending
          ? SortDirection.Ascending
          : SortDirection.Descending
      }
      onSelect={(filter) => onSortSelect(filter as SortByValue)}
      onSortChange={onSortOrderChange}
    />
  );
}
